/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The recording mode for the bot
 */
export type GetScheduledBotResponseInputDataRecordingMode =
  (typeof GetScheduledBotResponseInputDataRecordingMode)[keyof typeof GetScheduledBotResponseInputDataRecordingMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetScheduledBotResponseInputDataRecordingMode = {
  audio_only: "audio_only",
  speaker_view: "speaker_view",
  gallery_view: "gallery_view"
} as const
